import classNames from 'classnames';
import formStyle from '../style/WForm.less';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';
import { i18n } from '../../../i18n/i18n';
import * as React from 'react';
import { renderText } from '../../../bereiche/dateneingabe/assistent/assistent_helpers';
import Select from 'react-select';
import { WFormFieldSelectOptAsRadio } from './WFormFieldSelectOptAsRadio';
import { WFormFieldSelectOptAsSlider } from './WFormFieldSelectOptAsSlider';
// import { WFormFieldSelectOptAsCheckbox } from './WFormFieldSelectOptAsCheckbox';
// import { Guidance } from '../../../core/guidance/Guidance';

export interface WFormFieldSelectOption {
    index?: number;
    value: any;
    label: string | JSX.Element;
    labelGroup?: string;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}

interface WFormFieldSelectProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    entity?: string;
    value: string;
    row?: any;
    data?: any;
    required?: boolean;
    readonly?: boolean;
    showMode?: boolean;
    hidden_input?: boolean;
    hidden_msg?: string;
    output?: Array<string>;
    output_condition?: string;
    bundle_key?: string;
    bundle_value?: string;
    bundle_text?: string;
    bundle_assign?: Array<any>;
    bundle_text_unique?: boolean;
    options?: Array<any>;
    validationMsg?: string;
    layout?: string;
    multiple?: boolean;
    disableSearch?: boolean;
    asRadio?: boolean;
    asRadioForced?: boolean;
    asCheckbox?: boolean;
    asJaNein?: boolean;
    searchInFeld?: boolean;
    disabled?: boolean;
    valueDefaultOption?: string;
    disableDefaultOption?: boolean;
    showDisabledItems?: boolean;
    formContainerRef?: any;
    customStyle?: any;
    errorLevelKey?: string;
    helpKey?: string;
    isCombiItem?: boolean;
    sysTxtKeyHinweis?: string;
    onMenuOpen?: () => void;
    custom_component?: (setValue?: (value: string) => void, elementRef?: any, elementState?: any) => JSX.Element;
    onValueChange(name: string, value: any): void;
    filterOptions?(options: Array<any>, key: string, data: any): Array<any>; // Filter-Funktion für Options
    getFormData?(): any; // Funktion zum Holen der Formdaten (wg. Filter)
}

interface WFormFieldSelectState {
    options?: Array<any>;
    isMenuOpen?: boolean;
}

export class WFormFieldSelect extends React.Component<WFormFieldSelectProps, WFormFieldSelectState> {

    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.setOptions = this.setOptions.bind(this);
        this.setValue = this.setValue.bind(this);
        this.valueDefaultOption = this.props.valueDefaultOption || this.valueDefaultOption;
        this.state = {
            options: this.props.options ? this.props.options : []
        };
        this.selectRef = React.createRef();
    }

    private valueDefaultOption = i18n('keine Auswahl', 'sys');
    private selectRef: any = null;
    private hideAllDisabledItems: boolean = true;

    onChange(item: any) {
        let value = '';
        if (this.props.multiple) {
            const items = item;
            if (Array.isArray(items) && items.length > 0) {
                value = items.filter((r: any) => r.value)
                    .map((r: any) => r.value)
                    .sort((a, b) => a - b)
                    .join(',');
            }
        } else {
            if (item && item.value) {
                value = item.value;
            }
        }
        this.props.onValueChange(this.props.name, value);
        if (this.props.bundle_assign) {
            const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
            const item = (this.state.options || []).find((opt) => opt[fieldValue] === value);
            this.props.bundle_assign.forEach((assign) => {
                this.props.onValueChange(assign.TARGET_FIELD, item[assign.SOURCE_FIELD]);
            });
        }
    }

    UNSAFE_componentWillReceiveProps(props: any) {
        this.setOptions(props.options);
    }

    componentDidMount() {
        if (this.props.value === undefined || this.props.value === '') {
            this.props.onValueChange(this.props.name, 0);
        }
    }

    setOptions(options: Array<any>) {
        if (JSON.stringify(this.state.options) !== JSON.stringify(options)) {
            this.setState({ options });
        }
    }

    buildOptions(): Array<any> {
        let options = this.state.options || [];
        if (this.props.filterOptions && this.props.getFormData) {
            options = this.props.filterOptions(options, this.props.name, this.props.getFormData());
        }

        if (this.props.bundle_text_unique) {
            // Wirklich dreckig... geht aber leider wg. Subscope 1 nicht anders
            // Wir speichern eine beliebige TID, lösen dann später den Namen wieder auf
            // Und holen dann mit Jahr und Namen die korrekte TID ...
            const fieldText = this.props.bundle_text ? this.props.bundle_text : 'name';
            const mapSeen: any = {};
            const options_new: Array<any> = [];
            if (!options) {
                console.log('No Options for: ', this.props.name);
            }
            (options || []).forEach((o: any) => {
                const txt = o[fieldText];
                if (!mapSeen[txt]) {
                    mapSeen[txt] = true;
                    options_new.push(o);
                }
            });
            options = options_new;
        }

        // Alle ungültigen Optionen ausblenden
        if (!this.props.showDisabledItems && this.hideAllDisabledItems) {
            options = (options || []).filter((r: any) => !r.isDisabled);
        }

        return options;
    }

    buildWFormOptions(options: Array<any>): Array<any> {
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
        const optionsWForm = options.map((opt, idx: number) => {
            const option: WFormFieldSelectOption = {
                index: opt.index || opt.rfg,
                value: opt[fieldValue],
                label: this.renderSelectionItem(opt, idx),
                isDisabled: opt.isDisabled,
                ...(opt.labelGroup ? { labelGroup: opt.labelGroup } : {})
            };
            return option;
        }).sort((a: any, b: any) => {
            if (typeof a.index === 'number' && typeof b.index === 'number') {
                return a.index - b.index;
            }
            if (a.label && b.label) {
                return a.label.toString().toUpperCase().localeCompare(b.label.toString().toUpperCase());
            }
            return 0;
        });

        // Default
        const auswahlIdx = optionsWForm.findIndex((element: any) =>
            (element.label + '').toUpperCase() === (this.valueDefaultOption + '').toUpperCase());
        if (auswahlIdx !== -1) {
            optionsWForm.splice(auswahlIdx, 1);
        }
        if (!this.props.disableDefaultOption) {
            optionsWForm.splice(0, 0, { value: 0, label: this.valueDefaultOption, style: { color: 'grey', fontStyle: 'italic' } });
        }

        return optionsWForm;
    }

    buildWFormOptionGroups(options: Array<any>): Array<any> {
        let data: any = [];
        const groups: any = { _none: [] };

        if (options.find((option: any) => option.labelGroup)) {
            options.forEach((option: any) => {
                if (option.labelGroup) {
                    if (!groups[option.labelGroup]) {
                        groups[option.labelGroup] = [];
                    }
                    groups[option.labelGroup].push(option);
                } else {
                    groups._none.push(option);
                }
            });
            data = [...groups._none];
            delete groups._none;

            Object.keys(groups).forEach((group: string) => {
                data.push({ label: group, options: groups[group] });
            });
        }

        return data.length ? data : options;
    }

    getSelectedOpts(optionsWForm: Array<any>) {
        if (this.props.multiple) {
            if (typeof this.props.value === 'string' && this.props.value) {
                const values = this.props.value.split(',');
                return optionsWForm.filter((opt) => values.includes(opt.value + ''));
            }
        } else {
            return optionsWForm.find((opt) => opt.value + '' === (this.props.value ? this.props.value : 0) + '');
        }
        return null;
    }

    render() {
        const { layout, custom_component, customStyle, showMode, hidden_input, hidden_msg, errorLevelKey } = this.props;
        const complexLayout = (layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? true : false;

        // Options
        const options = this.buildOptions();
        const optionsWForm = this.buildWFormOptions(options);
        const selectedOpt = this.getSelectedOpts(optionsWForm);
        const optionGroupsWForm = this.buildWFormOptionGroups(optionsWForm);

        // Render - showMode
        const style: any = customStyle || {};
        const styleInput: React.CSSProperties = style.classInput || {};
        const styleSelect: React.CSSProperties = style.classSelect || {};
        const errInputStyle = typeof errorLevelKey === 'string' && errorLevelKey === 'error' ? formStyle.errorlevel_default : null;
        if (hidden_input) {
            styleSelect.display = 'none';
        }
        const krCls = getKomplexRowClassname((this.props.row || {})._formKey, this.props.name) || undefined;
        if (showMode) {
            const showText = selectedOpt ? selectedOpt.label : this.valueDefaultOption;
            return (
                <div ref={this.selectRef} className={classNames(formStyle.fieldBox, krCls)} style={style}>
                    {this.props.label}
                    <div
                        className={classNames(formStyle.input, formStyle.showMode, errInputStyle)}
                        style={{
                            overflow: 'hidden',
                            ...(showText === this.valueDefaultOption ? { color: 'grey', fontStyle: 'italic' } : {})
                        }}
                    >
                        {hidden_input ? '' : (showText || '')}
                    </div>
                </div>
            );
        }

        // Render - inputMode
        const isJaNein = (this.props.asJaNein || this.props.bundle_key === 'auswahl_ja_nein') && optionsWForm && optionsWForm.length === 2; // Ja/Nein Auswahl und nur zwei Optionen verfügbar
        const formRef = this.props.formContainerRef;
        const selRef = this.selectRef;
        const maxMenuHeight = 300;
        const optsHeight = optionsWForm.length * 30;
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        const heightOffset = selectedOpt && Array.isArray(selectedOpt.label) ? 20 : 0;
        const selectStyle = this.getSelectStyle(complexLayout, heightOffset);

        // let asCheckbox: boolean = this.props.asCheckbox;
        let asSlider: boolean = isJaNein && !complexLayout;
        let asRadio = !asSlider && this.props.asRadio;
        let asSelect: boolean = !asSlider && !asRadio;
        let asRadioForced = this.props.asRadioForced;
        if (asRadioForced) {
            asRadio = true;
            asSlider = false;
            asSelect = false;
        }

        // if (asCheckbox) {
        //     return (
        //         <div ref={this.selectRef} className={classNames(formStyle.fieldBox, krCls)} style={style}>
        //             <div
        //                 className={formStyle.input}
        //                 style={{ display: 'flex', flexDirection: 'row' }}
        //             >
        //                 <div style={{ width: '100%' }}>
        //                     <WFormFieldSelectOptAsCheckbox
        //                         label={this.props.label}
        //                         disabled={disabled}
        //                         selected={selectedOpt}
        //                         options={optionsWForm}
        //                         onChange={this.onChange}
        //                     />
        //                     {this.renderHinweis()}
        //                 </div>
        //             </div>
        //         </div>
        //     );
        // }

        return (
            <div ref={this.selectRef} className={classNames(formStyle.fieldBox, krCls)} style={style}>
                {!asSlider && this.props.label}
                <div
                    className={formStyle.input}
                    style={{
                        display: 'flex', flexDirection: 'row',
                        ...(complexLayout ? { alignItems: 'center' } : {}),
                        ...styleInput
                    }}
                >
                    <div style={{ width: '100%', ...styleSelect }}>
                        {asSlider &&
                            <WFormFieldSelectOptAsSlider
                                value={selectedOpt}
                                name={this.props.name}
                                entity={this.props.entity}
                                options={optionsWForm}
                                onChange={this.onChange}
                                disabled={disabled}
                                horizontal={this.isJaNeinOpt(options) || this.isShortOpt(options)}
                                layout={layout}
                                label={this.props.label}
                                helpKey={this.props.helpKey}
                                asJaNein={this.props.asJaNein}
                                customStyle={this.props.customStyle}
                            />
                        }
                        {asRadio &&
                            <WFormFieldSelectOptAsRadio
                                value={selectedOpt}
                                options={optionsWForm}
                                onChange={this.onChange}
                                disabled={disabled}
                                horizontal={this.isJaNeinOpt(options) || this.isShortOpt(options)}
                                layout={layout}
                            />
                        }
                        {asSelect &&
                            <Select
                                className={classNames(formStyle.select)}
                                ref={(ref: any) => this.setSelectClass(ref, errInputStyle)}
                                value={selectedOpt}
                                onChange={this.onChange}
                                onFocus={() => {
                                    // console.log(`Focus on "${this.props.name}"`);
                                    console.log(`Focus on "${this.props.helpKey || this.props.name}"`);
                                    // Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                                    // if (this.props.helpKey) {
                                    //     Guidance.instance?.setFieldAndEntity(this.props.helpKey, null);
                                    // } else {
                                    //     Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                                    // }
                                }}
                                // onBlur={() => Guidance.instance?.setFieldAndEntity(null, null) }
                                options={optionGroupsWForm}
                                placeholder={this.valueDefaultOption}
                                isSearchable={!this.props.disableSearch}
                                isDisabled={disabled}
                                styles={selectStyle}
                                maxMenuHeight={maxMenuHeight}
                                // filterOption={this.filterOption}
                                onMenuOpen={() => {
                                    if (typeof this.props.onMenuOpen === 'function') {
                                        this.props.onMenuOpen();
                                    }
                                    if (formRef && formRef.current && selRef && selRef.current) {
                                        const formDom = formRef.current.getBoundingClientRect();
                                        const selDom = selRef.current.getBoundingClientRect();
                                        // console.log(formDom, selDom);
                                        const minHeight = Math.min(optsHeight, maxMenuHeight);
                                        if (formDom && selDom && Math.abs(formDom.bottom - selDom.bottom) < minHeight) {
                                            // console.log(formDom.bottom, selDom.bottom, minHeight);
                                            setTimeout(() => {
                                                if (formRef.current) {
                                                    formRef.current.scrollBy(0, minHeight);
                                                }
                                            }, 100);
                                        }
                                    }
                                    this.setState({ isMenuOpen: true });
                                }}
                                onMenuClose={() => this.setState({ isMenuOpen: false })}
                                components={{
                                    ClearIndicator: this.getCustomClearIndicator(),
                                    DropdownIndicator: this.getCustomDropdownIndicator()
                                }}
                                isMulti={this.props.multiple ? this.props.multiple : false}
                                isClearable={false}
                            />
                        }
                        {this.renderHinweis()}
                    </div>
                    {(hidden_input && hidden_msg) &&
                        <i style={{ paddingTop: 5, color: '#666' }}>&nbsp;{hidden_msg}</i>
                    }
                    {typeof custom_component === 'function' &&
                        <div style={{ flex: 1 }}>{custom_component(this.setValue, selRef, this.state)}</div>
                    }
                </div>
            </div>
        );
    }

    getSelectStyle(complexLayout: boolean, heightOffset: number) {
        const { customStyle, isCombiItem } = this.props;
        let height: String | Number;
        if (this.props.multiple) {
            height = 'auto';
        } else {
            height = complexLayout ?
                isCombiItem ? 25 : 'var(--formfields-compact-height)' :
                isCombiItem ? 'var(--formfields-basis-height)' : `calc(var(--formfields-basis-height) + ${heightOffset}px)`;
            const customHeight = customStyle && customStyle[this.props.name] && customStyle[this.props.name].selectStyle && customStyle[this.props.name].selectStyle.height > 0 ?
                customStyle[this.props.name].selectStyle.height :
                customStyle && customStyle.selectStyle && customStyle.selectStyle.height > 0 ?
                    customStyle.selectStyle.height : undefined;
            height = customHeight || height;
        }

        // const defaultSettings = { minHeight: 1, height: height, padding: 0 };
        const defaultSettings = { minHeight: this.props.multiple ? 'var(--formfields-basis-height)' : 1, height, padding: 0 };

        const selectStyle = {
            option: (provided: any, state: any) => {
                // console.log('select state.data.style', state.data.style);
                const { color: dataColor, ...otherStyles } = state.data.style || {};
                return {
                    ...provided,
                    ...defaultSettings,
                    padding: 5,
                    height: '100%',
                    cursor:
                        state.isDisabled ? 'no-drop' : 'unset',
                    color:
                        state.isDisabled ? '#FFF' :
                            state.isSelected ? 'white !important'
                                : 'var(--color-wform-field-color)',
                    backgroundColor:
                        state.isDisabled ? 'var(--color-wform-field-bg-disabled)' :
                            state.isSelected ? 'var(--color-wform-field-color)'
                                : state.isFocused ? 'rgba(0,0,0,0.05)'
                                    : 'transparent',
                    '&:active': {
                        backgroundColor: 'var(--color-wform-field-color)'
                    },
                    ...otherStyles
                };
            },
            control: (provided: any, state: any) => {
                return {
                    ...provided,
                    ...defaultSettings,
                    fontSize: customStyle[this.props.name]?.selectStyle?.fontSize || 'var(--font-size-form-elements)',
                    width: '100%',
                    paddingLeft: 'var(--formfields-basis-padding-left)',
                    borderColor: 'var(--color-wform-field-color)',
                    borderRadius: 'var(--border-radius-form-elements)',
                    boxShadow: state.isFocused
                        ? `0 0 0 1px var(--color-wform-field-color)`
                        : null,
                    '&:hover': {
                        borderColor: 'var(--color-wform-field-color)'
                    }
                };
            },
            valueContainer: (provided: any, state: any) => { return { ...provided, ...defaultSettings }; },
            dropdownIndicator: (provided: any, state: any) => { return { ...provided, ...defaultSettings, color: 'var(--color-wform-field-color)' }; },
            indicatorsContainer: (provided: any, state: any) => { return { ...provided, ...defaultSettings }; },
            menuList: (provided: any) => ({ ...provided, maxHeight: 300 }),
            singleValue: (provided: any, state: any) => ({
                ...provided,
                color: 'var(--color-wform-field-color)'
            }),
            indicatorSeparator: () => ({ display: 'none' }),
            // Multi-Select
            multiValueContainer: (provided: any, state: any) => { return { ...provided, ...defaultSettings }; },
            multiValue: (provided: any, state: any) => ({
                ...provided,
                backgroundColor: 'transparent',
                color: 'var(--color-wform-field-color)'
            }),
            multiValueLabel: (provided: any, state: any) => ({
                ...provided,
                color: 'var(--color-wform-field-color)',
                fontSize: 'unset',
                padding: 0,
                paddingLeft: 0
            })
        };
        return selectStyle;
    }

    getCustomClearIndicator() {
        return (props: any) => {
            return (
                <div
                    {...props.innerProps}
                    style={{ padding: '0 5px', fontSize: '180%', color: 'var(--color-wform-field-color)' }}
                >
                    ×
                </div>
            );
        };
    }

    getCustomDropdownIndicator() {
        return (props: any) => {
            return (
                <div
                    {...props.innerProps}
                    style={{ padding: '0 5px', fontSize: 'larger', color: 'var(--color-wform-field-color)' }}
                >
                    🡫
                </div>
            );
        };
    }

    setValue(value: string) {
        this.props.onValueChange(this.props.name, value);
    }

    filterOption(option: any, rawInput: string) {
        if (rawInput === '') {
            return true;
        }
        if (option && option.label && option.label.props && typeof option.label.props.children === 'string'
            && option.label.props.children.toLowerCase().indexOf(rawInput.toLowerCase()) !== -1) {
            return true;
        }
        return false;
    }

    renderSelectionItem(item: any, idx: number) {
        const fieldText = this.props.bundle_text ? this.props.bundle_text : 'name';
        const output_condition = !this.props.output_condition || item[this.props.output_condition];
        const styleOption: any = (this.props.customStyle || {}).classOption || {};

        if (this.props.output && this.props.output.length > 0 && output_condition) {
            const parts: Array<JSX.Element | string> = [];
            if (item) {
                this.props.output.forEach((f, j: number) => {
                    let isBold = false;
                    if (f.substr(0, 2) === 'B:') {
                        isBold = true;
                        f = f.substr(2);
                    }
                    let value = '';
                    if (item.hasOwnProperty(f)) {
                        value = (item[f] ? item[f] : '-') + ' ';
                    } else {
                        if (f === '\n') {
                            parts.push(<br />);
                            return;
                        } else {
                            value = f + ' ';
                        }
                    }
                    if (isBold) {
                        parts.push(<b key={`sel_b_${idx}_${j}`}>{value}</b>)
                    } else {
                        parts.push(value);
                    }
                });
            }
            return (parts);
        } else if (Object.keys(styleOption).length && styleOption[item.tid || null]) {
            return <span style={styleOption[item.tid]}>{item[fieldText]}</span>;
        }
        return item[fieldText];
    }

    isJaNeinOpt(options: Array<any>) {
        // console.log('SEL_CHECK: ', this.props.key, options);
        if (!options) {
            return false;
        }
        const text = options.map((o: any) => o.name).sort().join(',').toLowerCase();
        if (text === 'ja,nein') {
            return true;
        }
        return false;
    }

    isShortOpt(options: Array<any>) {
        if (!options) {
            return false;
        }
        const text = options.map((o: any) => o.name).sort().join(',').toLowerCase();
        if (text.length < 50) {
            return true;
        }
        return false;
    }

    setSelectClass(ref: any, name: string): void {
        if (!ref) {
            return;
        }
        const control: DOMTokenList = (((ref || {}).select || {}).controlRef || {}).classList;
        if (name && control) {
            control.add(name);
        }
    }

    renderHinweis() {
        const { sysTxtKeyHinweis, data } = this.props;
        if (sysTxtKeyHinweis) {
            return <div className={formStyle.hinweis}>
                {renderText(sysTxtKeyHinweis, data)}
            </div>;
        }
        return null;
    }
}
